/**
 * @file Defines the {@link IS_IE} constant
 */

/** Detect whether browser is IE */
export const IS_IE = document.documentMode || /Edge/.test(navigator.userAgent)